<template>
  <slot />

  <teleport to="body">
    <div
      ref="containerRef"
      class="watermark-wrapper"
    >
      <div style="height: 100vh; z-index: 9999999">
        <div
          class="watermark-layer"
          :style="{
            zIndex: zIndex,
            backgroundImage: `url(${urls[0]})`,
            backgroundSize: backgroundSize,
            opacity: activeLayer === 0 ? 1 : 0,
          }"
        />
        <div
          class="watermark-layer"
          :style="{
            zIndex: zIndex,
            backgroundImage: `url(${urls[1]})`,
            backgroundSize: backgroundSize,
            opacity: activeLayer === 1 ? 1 : 0,
          }"
        />
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';

const props = defineProps({
  // 传入数组，例如：['用户名：张三', '2023-10-27 12:00:00']
  content: { type: Array, default: () => [] },
  width: { type: Number, default: 340 }, // 稍微加宽一点，容纳长文字
  height: { type: Number, default: 260 }, // 稍微加高一点，容纳两行
  fontSize: { type: Number, default: 14 },
  fontColor: { type: String, default: 'rgba(128, 128, 128, 0.14)' },
  rotate: { type: Number, default: -22 },
  lineHeight: { type: Number, default: 22 }, // 行间距
  zIndex: { type: Number, default: 999999 },
});

const activeLayer = ref(0);
const urls = ref(['', '']);
const backgroundSize = computed(() => `${props.width}px ${props.height}px`);
/**
 * 生成多行 SVG 水印
 */
const createSvgUrl = (texts) => {
  // 动态生成多行 text 标签
  // y 坐标计算：让文字组整体在中心垂直居中
  const startY = 50 - ((texts.length - 1) * ((props.lineHeight / props.height) * 100)) / 2;

  const textElements = texts
    .map((text, i) => {
      const yPos = `${startY + i * ((props.lineHeight / props.height) * 100)}%`;
      return `
        <text 
          x="50%" 
          y="${yPos}" 
          fill="${props.fontColor}" 
          font-size="${i == 0 ? 18 : props.fontSize}" 
          font-family="sans-serif"
          text-anchor="middle" 
          dominant-baseline="middle"
        >${text}</text>
      `;
    })
    .join('');

  const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="${props.width}" height="${props.height}">
        <g transform="rotate(${props.rotate} ${props.width / 2} ${props.height / 2})">
          ${textElements}
        </g>
      </svg>`.trim();

  return `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(svg)))}`;
};

// 监听数组变化（注意：Vue 监听数组需要开启 deep）
watch(
  () => [...props.content],
  (newVal) => {
    const nextLayer = activeLayer.value === 0 ? 1 : 0;

    // 1. 在隐藏层准备好新水印
    urls.value[nextLayer] = createSvgUrl(newVal);

    // 2. 延迟切换，消除火狐图片的加载瞬间
    setTimeout(() => {
      activeLayer.value = nextLayer;
    }, 60);
  },
  { immediate: true },
);
</script>

<style scoped>
.watermark-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: transparent;
}

.watermark-layer {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 99999 !important; /* 强制最高 */
  pointer-events: none !important;
  background-repeat: repeat !important;
}
</style>
